exports = module.exports = require("../../../../../../css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".dv-decoration-3{width:100%;height:100%}.dv-decoration-3 svg{transform-origin:left top}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/@jiaminghi/data-view/lib/components/decoration3/src/main.css
// module id = 1089
// module chunks = 45